// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"styles_balanceWrapper__+PWfB","balanceItem":"styles_balanceItem__bLCGW"};